import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const footerLinks = [
  {
    title: "Explore",
    links: [
      { to: "/kanzi", label: "Kanzi" },
      { to: "/bonobos", label: "Bonobos" },
      { to: "/bonobo-language-research", label: "Language Research" },
      { to: "/lexigrams", label: "Lexigrams" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/keyboard", label: "Keyboard" },
      { to: "/research", label: "Research" },
      { to: "/sue-savage-rumbaugh", label: "Sue Savage-Rumbaugh" },
      { to: "/video", label: "Video Archive" },
      { to: "/SueBiblio", label: "Bibliography" },
    ],
  },
  {
    title: "Support",
    links: [
      { to: "/donate", label: "Donate" },
      { to: "/store", label: "Store" },
      { to: "/kanzi", label: "Kanzi" },
      { to: "/privacy-policy", label: "Privacy Policy" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <section className="site-footer__brand" aria-label="Bonobo Hope Initiative">
          <Link className="site-footer__logo" to="/">
            <img src="/bonobo-hope-logo.png" alt="Bonobo Hope Initiative" />
          </Link>
          <p>
            Bonobo Hope Initiative works to restore and continue bonobo and
            chimpanzee language research through lexigrams, public education,
            archival access, and advocacy for bonobo dignity.
          </p>
        </section>

        <nav className="site-footer__nav" aria-label="Footer navigation">
          {footerLinks.map((group) => (
            <div className="site-footer__group" key={group.title}>
              <h2>{group.title}</h2>
              <ul>
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>

      <div className="site-footer__bottom">
        <span>© 2013-2026 Bonobo Hope Initiative</span>
        <a href="mailto:info@bonobohope.org">info@bonobohope.org</a>
        <Link to="/privacy-policy">
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
